module.exports = function() {
  return new Worker(__webpack_public_path__ + "f7198af4d50d231827e0.worker.js");
};